var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"videoSkeleton"},[_c('skeleton-box',{staticClass:"videoSkeleton-video"}),(_vm.showControllers)?_c('skeleton-box',{staticClass:"videoSkeleton-controller"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }